"use strict";
(function (Drupal, once) {
    Drupal.behaviors.toggleMobileExpanedMenuTopItems = {
        attach: function (context) {
            once('toggleMobileExpanedMenuTopItems', '.js-mobile-expanded-menu-top-level-title', context).forEach(function (element) {
                element.addEventListener('click', function (event) {
                    const mobileExpandedMenuTopItems = element.nextElementSibling;
                    const chevronDownSVG = element.querySelector('.js-chevron-down');
                    const minusSVG = element.querySelector('.js-minus');
                    const allMobileExpandedMenuTopItems = document.querySelectorAll('.js-mobile-expanded-menu-top-items');
                    if (mobileExpandedMenuTopItems.classList.contains('js-mobile-expanded-menu-top-items')) {
                        // Close all previously opened menu items
                        allMobileExpandedMenuTopItems.forEach(function (item, _, __) {
                            const itemElement = item;
                            if (itemElement !== mobileExpandedMenuTopItems) {
                                itemElement.classList.add('hidden');
                                const titleElement = itemElement.previousElementSibling;
                                titleElement.classList.add('border-b-1', 'pb-4');
                                element.classList.remove('pb-2');
                                const chevronDown = titleElement.querySelector('.js-chevron-down');
                                const minus = titleElement.querySelector('.js-minus');
                                chevronDown.classList.remove('hidden');
                                minus.classList.add('hidden');
                            }
                        });
                        if (mobileExpandedMenuTopItems.classList.contains('hidden')) {
                            mobileExpandedMenuTopItems.classList.remove('hidden');
                            element.classList.remove('border-b-1', 'pb-4');
                            element.classList.add('pb-2');
                            if (chevronDownSVG && minusSVG) {
                                chevronDownSVG.classList.add('hidden');
                                minusSVG.classList.remove('hidden');
                            }
                        }
                        else {
                            mobileExpandedMenuTopItems.classList.add('hidden');
                            element.classList.add('border-b-1', 'pb-4');
                            if (chevronDownSVG && minusSVG) {
                                minusSVG.classList.add('hidden');
                                chevronDownSVG.classList.remove('hidden');
                            }
                        }
                    }
                });
            });
        },
    };
})(Drupal, once);
